//Context store for registration wizard
import React, { useState } from 'react';

const RegistrationContext = React.createContext([{}, p => {}]);

const RegistrationProvider = (props) => {
    const [registrationState, setRegistrationState] = useState({
        EventId: "",
        SignedWaiver: false,
        Name: "",
        Email: "",
        DOB: "",
        Gender: "",
        Phone: "",
        Questions: [],
        CustomerXRef: "",
        Processed: false,
        CCNumber: "",
        CCName: "",
        CCExpiry: "",
        CCCvc: "",
        CCIssuer: "",
        CCZip: "",
        Notes: "",
        focused: "",
        formData: null,
        sentEmail: false,
        EventEnabled: false,
        EventImage: "",
        EventImagePublicId: "",
        EventTitle: "",
        EventSubTitle: "",
        EventDescription: "",
        EventType: "",
        EventContact: "",
        EventPhone: "",
        EventEmail: "",
        EventOtherWebsite: "",
        EventLocation: "",
        EventStartDate: "",
        EventEndDate: "",
        EventAgeRestriction: "",
        EventGenderRestriction: "",
        EventYoungerThan: "",
        EventRequireWaivers: false,
        EventRequireNameEmail: false,
        EventRequireDOB: false,
        EventRequireGender: false,
        EventRequirePhone: false,
        EventIncludeQuestions: false,
        EventIncludedQuestions: [],
        EventRegistrations: [],
        EventAcceptOnlineRegistration: false,
        EventPrice: 0,
        EventMaxRegistrations: 8,
        EventAfterSubmit: "",
        Type: "",
        Event: "",
        EventListDisabled: true,
        eventsList:[]
    });
    return (
        <RegistrationContext.Provider value={[registrationState, setRegistrationState]}>
            {props.children}
        </RegistrationContext.Provider>
    );
};

export { RegistrationContext, RegistrationProvider };
